// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/lithium-battery-hazards.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/lithium-battery-hazards/lithium-battery-hazards.js';

mount([g0]);
